export default __webpack_public_path__ + "static/media/logo_transeleva.a7a1f8a1.png";